import logo from "./logo.svg";
// import "./App.css";
import { RouterProvider } from "react-router-dom";
import Router from "./routes/router";
import { Toaster } from "react-hot-toast";
import { NityaSevaMemberProvider } from "./context/NityaSevaMemberContext";

function App() {
  return (
    <>
      <NityaSevaMemberProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,

            success: {
              style: {
                border: "1px solid #22c55e",
              },
            },

            error: {
              style: {
                border: "1px solid #ef4444",
              },
            },
          }}
        />
        <Router />
      </NityaSevaMemberProvider>
    </>
  );
}

export default App;
